import Notifications from './Notifications.vue'

export default class AppNotify {
    constructor () {
        // this.messages = [];
        this.next_id = 1;
    }
    init (Vue) {
        Vue.util.defineReactive(this, 'messages', []);
    }

    _post_message (message, type, timeout) {
        this.messages.push({
            id: this.next_id,
            message: message,
            type: type,
            timeout: timeout,
        });

        if (timeout) {
            setTimeout((current_id) => {
                this.remove(current_id);
            }, timeout, this.next_id);
        }
        this.next_id++;
    }

    remove (id) {
        let msg = this.messages.findIndex((item) => {
            return item.id == id;
        });

        if (msg >= 0) {
            this.messages.splice(msg, 1);
        }
    }

    success (message, timeout) {
        this._post_message(message, 'success', timeout);
    }
    error (message, timeout) {
        this._post_message(message, 'error', timeout);
    }
    info (message, timeout) {
        this._post_message(message, 'info', timeout);
    }
    warning (message, timeout) {
        this._post_message(message, 'warning', timeout);
    }
}

AppNotify.install = (Vue) => {
    if (AppNotify.install.installed) return;
    AppNotify.install.installed = true;

    Vue.mixin({
        beforeCreate () {
            // console.dir(this);
            if (this.$options.notify !== undefined) {
                this._rootVue = this;
                this._instance = this.$options.notify;
                this._instance.init(Vue);
            }
            else if (this.$options.parent) {
                if (this.$options.parent.$notify) {
                    this._instance = this.$options.parent.$notify;
                }
            }
        }
    });

    Object.defineProperty(Vue.prototype, '$notify', {
        get () { return this._instance }
    })
    Object.defineProperty(Vue.prototype, '$messages', {
        get () { return this._instance.messages }
    })

    Vue.component('app-notifications', Notifications);
}
